import { CameraIcon } from "@heroicons/react/24/outline";
import { SecondaryButton } from "components/ui/secondary-button";
import React, { useCallback } from "react";
import { navigate } from "store/actions";
import { handleEvent } from "util/user-events";

export const ScanBusinessCardButton: React.FC = () => {
    const handleClick = useCallback(() => {
        handleEvent("scan-business-card-start");
        navigate("/references/scan-business-card");
    }, []);

    return (
        <SecondaryButton onClick={handleClick}>
            <div className="flex items-center md:space-x-2">
                <CameraIcon className="w-5 h-5" />
                <span className="text-sm max-md:hidden">Scan business card</span>
            </div>
        </SecondaryButton>
    );
};
